module.exports = __webpack_public_path__ + "media/images/svg/jobs/truck-635510fb2a39a484404d589dc9fdf515.svg";